export const dialogPageTypes  = {
    user:"utenti",
    building:"building",
    zone:"zone",
    stanze:"stanze",
    postazioni : "postazioni",
    historyDatatable: "historyDatatable"
}